<!-- @component `SimpleTimeline` [Read the docs.](https://reuters-graphics.github.io/graphics-components/?path=/docs/components-SimpleTimeline--default) -->
<script>
  /**
   * An array of dates with events.
   * @required
   */
  export let dates;
  /**
   * Set a colour for the timeline bullet symbols and line.
   * @type {string}
   */
  export let symbolColour = 'var(--theme-colour-brand-rules)';
  /**
   * Set a colour for the date headings in the timeline.
   * @type {string}
   */
  export let dateColour = 'var(--theme-colour-accent, red)';
  /**
   * Set a class to target with SCSS.
   * @type {string}
   */
  let cls = '';
  export { cls as class };
  /**
   * Set an ID to target with SCSS.
   * @type {string}
   */
  export let id = '';

  /**
   * The height of the list in the SimpleTimeline component.
   * @type {number}
   */
  export let listHeight = 0;

  import { Block } from '@reuters-graphics/graphics-components';
  import { Markdown } from '@reuters-graphics/svelte-markdown';
</script>

<Block width="normal" {id} class="simple-timeline-container {cls}">
  <div
    bind:clientHeight={listHeight}
    class="timeline pl-2 pr-3.5"
    style="--symbol-colour:{symbolColour};"
  >
    {#each dates as date}
      <div class="date relative pt-0.5 pl-5 pb-4">
        <svg class="absolute bg" height="25" width="20">
          <circle
            cx="10"
            cy="12"
            r="5"
            stroke={symbolColour}
            stroke-width="2"
            fill="transparent"
          ></circle>
        </svg>
        <div class="timeline-date" style:color={dateColour}>
          {date.date}
        </div>
        {#each date.events as event}
          <div class="event">
            {#if event.titleLink}
              <a href={event.titleLink}>
                <div class="title">
                  {event.title}
                  <!-- <span class="text-sm"><Fa fw icon="{faLink}" /></span> -->
                </div>
              </a>
            {:else}
              <div class="title">
                {event.title}
              </div>
            {/if}
            {#if event.context}
              <Markdown source={event.context} />
            {/if}
          </div>
        {/each}
      </div>
    {/each}
  </div>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;
  .timeline {
    padding-left: 0.5rem;
    padding-right: 0.875rem;
    .date {
      position: relative;
      padding-top: 0.125rem;
      padding-left: 1.25rem;
      padding-bottom: 1rem;
      scroll-snap-align: start;
      border-left: 1px solid var(--symbol-colour);
      &:last-child {
        border-left: 1px solid mixins.$theme-colour-background;
        @include mixins.fpb-0;
      }
    }

    .timeline-date {
      @include mixins.font-note;
      @include mixins.text-xs;
      text-transform: uppercase;
      @include mixins.font-black;
      @include mixins.tracking-wide;
      @include mixins.fmb-0;
    }

    svg {
      top: -1px;
      left: -10.5px;
    }
    div.title {
      @include mixins.h3;
      @include mixins.fmy-1;
      @include mixins.font-medium;
    }

    div.event {
      a {
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      a div.title {
        span {
          opacity: 0.5;
        }
        &:hover span {
          opacity: 0.8;
        }
      }
      :global(p) {
        @include mixins.body-note;
        @include mixins.font-light;
      }
    }
  }
</style>
